<div class="tag" [class]="appearance + ' size-' + tagSize" [ngStyle]="{ background: this.background }">
    @if (appearance !== 'svg-only') {
    <span hSrOnlyNoSnippet>
        <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
    </span>
    }
    <span class="svg" [ngClass]="{ 'with-text': appearance !== 'svg-only' }">
        <ng-content select="[svg]"></ng-content>
    </span>
    <span class="text">
        <ng-content></ng-content>
    </span>
</div>
